





import { BooleanProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconReadIndicator extends Vue {
  @BooleanProp()
  private readonly read!: boolean;
}
